import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit';
import { axiosInstance } from '../../axios/axiosInterceptor';
import { UserDetailsResponse, UserDetailsState } from './userDetails.types';

const userDetailsURL = '/moo/employee/me';

const initialState: UserDetailsState = {
  status: 'idle',
  response: null,
};

export const getUserDetails = createAsyncThunk('userDetails', async (_, { rejectWithValue }) => {
  const result = await axiosInstance
    .get(userDetailsURL)
    .then((response) => response?.data)
    .catch((error) => {
      throw rejectWithValue(error);
    });
  return result;
});

// Slice
const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {},
  extraReducers(builder: ActionReducerMapBuilder<UserDetailsState>) {
    builder
      .addCase(getUserDetails.pending, (state: UserDetailsState) => {
        state.status = 'Pending';
      })
      .addCase(
        getUserDetails.fulfilled,
        (state: UserDetailsState, action: PayloadAction<UserDetailsResponse>) => {
          state.status = action.payload?.data?.isSuccess ? 'Success' : 'Failed';
          state.response = action.payload.data.payload;
        },
      )
      .addCase(getUserDetails.rejected, (state: UserDetailsState) => {
        state.status = 'Failed';
        state.response = null;
      });
  },
});

export const getUserDetailsStatus = (state: { userDetails: UserDetailsState }) => state.userDetails;
export default userDetailsSlice.reducer;
